import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '../shared/ui';
import { VersionUpdateService } from './version-update.service';

/**
 * Fixed, dismissible "new version deployed" banner. Mounted once in the
 * root `App` template so it covers every route; it only ever renders for
 * signed-in users because {@link VersionUpdateService} doesn't subscribe
 * to the version doc while signed out.
 */
@Component({
  selector: 'app-version-update-banner',
  imports: [ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (versions.updateAvailable()) {
      <div class="version-banner" role="status" aria-live="polite">
        <span class="version-banner-text">A new version of GHOSTS is available.</span>
        <app-button variant="primary" (click)="versions.reloadPage()">Refresh</app-button>
        <app-button variant="icon" ariaLabel="Dismiss" (click)="versions.dismiss()">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M3.5 3.5l7 7M10.5 3.5l-7 7"
              stroke="currentColor"
              stroke-width="1.4"
              stroke-linecap="round"
            />
          </svg>
        </app-button>
      </div>
    }
  `,
  styleUrl: './version-update-banner.component.scss',
})
export class VersionUpdateBannerComponent {
  protected readonly versions = inject(VersionUpdateService);
}
